$(document).ready(function(){

if(window.location.hash == '#index-discount-newslatter-form'){
  window.history.replaceState({},null,window.location.href.split("#")[0]);
}

    $(document).on('change', '#custom_form_cheang', function() {
          $("#all_countery_form .pxFormGenerator").addClass('form_hidden');
        	var $select_val = $(this).val();
          $($select_val).removeClass('form_hidden');
        }); 

  
// megamenu jS
$( ".wrp_sec_level .is_accordion" ).on( "click", function() {
      if($(this).hasClass('is_active')) {
      $(this).find('.super_wrp_third_level').slideUp();
      $(this).removeClass('is_active');
    }
    else {
      $('.super_wrp_third_level').slideUp();
      $('.wrp_sec_level .is_accordion').removeClass('is_active');
      $(this).find('.super_wrp_third_level').slideToggle();
      $(this).toggleClass('is_active');
    }
});  
// end mega-menu JS
  var maxHeight = 0;
  $(".text_column_icon_img").each(function(){
    if ($(this).height() > maxHeight) { maxHeight = $(this).height(); }
  });
  $(".text_column_icon_img").height(maxHeight);

  var maxHeight = 0;
  $(".collection-content .grid-product__title").each(function(){
    if ($(this).height() > maxHeight) { maxHeight = $(this).height(); }
  });
  $(".collection-content .grid-product__title").height(maxHeight);

  $('.cm_pro_main').slick({
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 2,
    dots: false,
    arrows: true
  });

  $('.text_and_image_slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    adaptiveHeight: true,
    autoplay: false,
    responsive: [
    {
      breakpoint: 769,
      settings: {
       dots: false,
       autoplay: true
      }
    }
  ]
  });

  $('.cm_testimonials_slider').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    centerMode: true,
    centerPadding: '200px',
    responsive: [
    {
      breakpoint: 1500,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 960,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 599,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerPadding: '100px'
      }
    },
    {
      breakpoint: 414,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerPadding: '20px'
      }
    }
  ]
  });

  $('.logo_bar_slider .logo-bar').slick({
    infinite: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 599,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    }
  ]
  });

  if ($(window).width() < 600) {
    $('.logo_mobile_slider .logo-bar,.logo_mobi_slider').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: true,
      arrows: false
    });
  }

  setTimeout(function () {
    $('.recommendations_slider,.featured_cslider').slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: true,
      arrows: false,
      responsive: [
      {
        breakpoint: 992,
        settings: {
         slidesToShow: 3,
         slidesToScroll: 1
        }
      },
      {
        breakpoint: 600,
        settings: {
         slidesToShow: 2,
         slidesToScroll: 1
        }
      }
    ]
    });
  },1000);

  if ($(window).width() < 769) {
    $('.tab_collection').slick({
      infinite: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      dots: true,
      arrows: false
    });

    $('.collection_mob_slider').slick({
      infinite: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      dots: true,
      arrows: false
    });
  
    // $('.footer_badge').slick({
    //   infinite: true,
    //   slidesToShow: 2,
    //   slidesToScroll: 1,
    //   dots: false,
    //   centerMode: true,
    //   centerPadding: '60px',
    //   arrows: false,
    //   responsive: [
    //   {
    //     breakpoint: 600,
    //     settings: {
    //       slidesToShow: 1,
    //       slidesToScroll: 1
    //     }
    //   }
    // ]
    // });
  }

  $('.newsletter-section__content').on("contextmenu",function(){
       return false;
  }); 

  $('.discount_form ').on("contextmenu",function(){
       return false;
    });
  
});


// ************ Faq page and collection page tab ************

$(".faq_tab_btn_main, .collection_tab_btn").find("li").each(function(){
  $(this).find("button, a").click(function(){
    if($(window).width() < 769){
      $(".tab_collection").slick("refresh")
    }
    var getClick = $(this).attr("data-tab-category");
    $(this).closest("li").addClass("active").siblings().removeClass("active");
    $(".collection_info").find(".tab_collection").each(function(){
      var getCategory = $(this).attr("data-category");
      if (getClick == getCategory) {
        $(this).css("display","block");
      }
      else{
        $(this).css("display","none");
      }
    });
  });
})

var currantCategory = $(".collection_tab_btn").find(".active button").attr("data-tab-category");

$(".collection_info").find(".tab_collection").each(function(){
  var getCategory = $(this).attr("data-category");
  if (currantCategory == getCategory) {
    $(this).css("display","block");
  }
  else{
    $(this).css("display","none");
  }
});

document.getElementById('ft_bottom_menu_selection').onchange = function() {
    window.location.href = this.children[this.selectedIndex].getAttribute('href');
}
$(function() {
  $(".js-scroll-to-id").click(function(e) {
    var destination = $(this).find('a').attr('href');
    e.preventDefault();
   if($(window).width() < 1000){
    $('html, body').animate({
      scrollTop: $(destination).offset().top -130
    }, 1500);
   }
    else{
    $('html, body').animate({
        scrollTop: $(destination).offset().top -200
      }, 1500);
    }
  });
});

// load more product on collection page
$('.js-load-more-blog').on('click', function(){
    var $this =$(this),totalPages = parseInt($('[data-total-pages]').val()),currentPage = parseInt($('[data-current-page]').val());
    $this.attr('disabled', true);
    $this.find('[loader]').removeClass('hide');
    $this.find('[load-more-text]').addClass('hide');
    currentPage = currentPage+1;
    var nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/,'page='+currentPage);
    $('[data-current-page]').val(currentPage);
    $.ajax({
      url: nextUrl,
      type: 'GET',
      dataType: 'html',
      success: function(responseHTML){
        $('.grid--uniform').append($(responseHTML).find('.grid--uniform').html());
        $("image-element").addClass("aos-init aos-animate");
      },
      complete: function() {
        if(currentPage <= totalPages) {
          $this.attr('disabled', false); $this.find('[load-more-text]').removeClass('hide'); $this.find('[loader]').addClass('hide');
           if(currentPage == totalPages) {
           $this.hide();
           }
          $('.load-more_wrap').addClass('load_more_hide');
        } 
      }
    })
  });

$(".mobile-nav .disclosure__toggle").click(function(){
    $(".disclosure-list").toggleClass("disclosure-list--visible");
});
$(".mobile-nav .disclosure-list").find(".disclosure-list__item").each(function(){
  $(this).click(function(e){
    e.preventDefault();
    var currntPath = $(this).find('a').attr("data-value");
    if (currntPath == "en"){
       window.location.href = '/en'+location.pathname;
    }
    else{
      var url = location.pathname.replace("/en/","");
      window.location.href = '/'+url;
    }
  });
});
  
$(".country_dropdown").find(".country-select option").each(function(){
var thisvalue = $(this).attr("value");
  if (thisvalue == '---') {
    $(this).remove();
  }
});
$("predictive-search").find("form .btn--close-search").click(function(e){
  e.preventDefault();
  $(this).closest(".predictive-search, .site-header__search-container").removeClass("is-active");
});

 document.addEventListener("contextmenu", function (e){
    e.preventDefault();
}, false);
